import { boisson } from "@/models/model.js";
import { mapped } from '@/lib/counted.js';

//+ [Item] -> {Item.name: {count, Item} }
const empty = () => {
    return mapped(boisson, b => b.nom)
};

export { empty };
